import { useState, useRef, useEffect } from "react";
import { FiMoreVertical } from "react-icons/fi";

const RowAction = ({ actions = [], row }) => {
  const [open, setOpen] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0, transformOrigin: "top right" });

  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target) &&
          buttonRef.current && !buttonRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  useEffect(() => {
    const closeOnScroll = () => setOpen(false);
    if (open) window.addEventListener("scroll", closeOnScroll, true);
    return () => window.removeEventListener("scroll", closeOnScroll, true);
  }, [open]);

  const toggleMenu = () => {
      if (!buttonRef.current) return;

      const rect = buttonRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      
      const menuWidth = 192; 
      const menuHeight = actions.length * 42 + 12;

      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;
      // spaceRight வரி நீக்கப்பட்டது (unused warning fix)

      let top = rect.bottom + 8;
      let left = rect.right - menuWidth; 
      let originY = "top";
      let originX = "right";

      // --- Vertical Positioning ---
      if (spaceBelow < menuHeight && spaceAbove > menuHeight) {
        top = rect.top - menuHeight - 8;
        originY = "bottom";
      }

      // --- Horizontal Positioning ---
      if (left < 8) {
        left = rect.left; 
        originX = "left";
      }

      if (left + menuWidth > viewportWidth - 8) {
        left = viewportWidth - menuWidth - 8;
        originX = "right";
      }

      setMenuPos({ 
        top, 
        left, 
        transformOrigin: `${originY} ${originX}` 
      });
      setOpen(!open);
    };

  return (
    <div className="relative inline-block text-left">
      <button
        ref={buttonRef}
        onClick={(e) => {
          e.stopPropagation();
          toggleMenu();
        }}
        className={`p-2 rounded-full transition-all duration-200 ${
          open ? "bg-red-50 text-red-600 shadow-inner" : "hover:bg-gray-100 text-gray-500"
        }`}
      >
        <FiMoreVertical size={20} />
      </button>

      {open && (
        <div
          ref={menuRef}
          style={{
            position: "fixed",
            top: menuPos.top,
            left: menuPos.left,
            transformOrigin: menuPos.transformOrigin,
          }}
          className="w-48 bg-white border border-gray-100 rounded-xl shadow-[0_10px_25px_-5px_rgba(0,0,0,0.1),0_8px_10px_-6px_rgba(0,0,0,0.1)] z-[9999] overflow-hidden animate-in fade-in zoom-in duration-200"
        >
          <div className="p-1.5">
            {actions.map((action, i) => {
              // Check both show and renderCondition properties
              const isVisible = action.show ? action.show(row) !== false : (action.renderCondition ? action.renderCondition(row) !== false : true);
              if (!isVisible) return null;

              const isDisabled = typeof action.disabled === "function" ? action.disabled(row) : action.disabled;
              const isDanger = typeof action.danger === "function" ? action.danger(row) : action.danger;
              const label = typeof action.label === "function" ? action.label(row) : action.label;
            
              return (
                <button
                  key={i}
                  disabled={isDisabled}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (isDisabled) return;
                    setOpen(false);
                    action.onClick(row);
                  }}
                  className={`flex items-center gap-3 w-full text-left px-3 py-2.5 text-sm font-medium rounded-lg transition-colors
                    ${isDisabled 
                      ? "text-gray-300 cursor-not-allowed" 
                      : isDanger 
                        ? "text-red-600 hover:bg-red-50" 
                        : "text-gray-700 hover:bg-gray-50"
                    }`}
                >
                  {action.icon && (
                    <span className={`text-lg ${isDisabled ? "text-gray-300" : isDanger ? "text-red-500" : "text-gray-400"}`}>
                      {action.icon}
                    </span>
                  )}
                  {label}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default RowAction;